import { render, staticRenderFns } from "./TimeSlots.vue?vue&type=template&id=0afbd6c1"
import script from "./TimeSlots.vue?vue&type=script&lang=js"
export * from "./TimeSlots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports